import React, { Component, createRef } from 'react';
import { URLImgFront } from '../config/URLDB';
import Header from '../components/Principal/Header';
import Footer from '../components/Principal/Footer';
import MensajeF from '../components/Mensaje_Flotante/MensajeF';
import Principal from '../components/EstrategiasComerciales/Infantil/Coopenautas/Principal';
import Informacion from '../components/EstrategiasComerciales/Infantil/Coopenautas/Informacion';
import Fechas from '../components/EstrategiasComerciales/Infantil/Coopenautas/Fechas';
import Premios from '../components/EstrategiasComerciales/Infantil/Coopenautas/Premios';
import TiendaPremios from '../components/EstrategiasComerciales/Infantil/Coopenautas/TiendaPremios';

class Coopenautas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            panelActivo: 1,
            puntos: '',
            nivelaso: null,
            correo: null,
            telcel: null,
            idcliente: null,
            nomcom: null,
            nit: null,
            tipoiden: null,
            mostrarConsulta: false
        }

        this.Informacion = createRef(); //Seccion 2
        this.Premios = createRef();     //Seccion 3
        this.Fechas = createRef();      //Seccion 4
        this.Tienda = createRef();      //Seccion 4
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    navegarSeccion = (seccion) => {
        const secciones = {
            2: this.Informacion,
            3: this.Premios,
            4: this.Fechas,
            5: this.Tienda,
        };

        if (secciones[seccion] && secciones[seccion].current) {
            secciones[seccion].current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    mostrarPanel = (mostrar) => {
        this.setState({ panelActivo: mostrar });
    }

    asignarDatosBasicos = (nivelaso, idcliente, puntos, nomcom, nit, correo, telcel, tipoiden) => {
        this.setState(prevState => ({
            nivelaso: nivelaso ?? prevState.nivelaso,
            idcliente: idcliente ?? prevState.idcliente,
            puntos: puntos ?? prevState.puntos,
            nomcom: nomcom ?? prevState.nomcom,
            nit: nit ?? prevState.nit,
            correo: correo ?? prevState.correo,
            telcel: telcel ?? prevState.telcel,
            tipoiden: tipoiden ?? prevState.tipoiden
        }))
    }

    mostrarConsulta = (mostrar, panel) => {
        this.setState({ mostrarConsulta: mostrar });
        this.mostrarPanel(panel);
    }

    render() {
        return (
            <div style={{ backgroundImage: `url(${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/FondoBlanco.webp)` }}>
                <Header id={2} />
                <div style={{ paddingTop: '118px' }}>
                    <Principal navegarSeccion={this.navegarSeccion} mostrarPanel={this.mostrarPanel} asignarDatosBasicos={this.asignarDatosBasicos} OnMostrarConsulta={this.mostrarConsulta} mostrarConsulta={this.state.mostrarConsulta} />
                </div>
                {(() => {
                    switch (this.state.panelActivo) {
                        case 1:
                            return (
                                <div>
                                    <div ref={this.Informacion}>
                                        <Informacion />
                                    </div>
                                    <div ref={this.Premios}>
                                        <Premios />
                                    </div>
                                    <div ref={this.Fechas}>
                                        <Fechas />
                                    </div>
                                </div>
                            );
                        case 2:
                            return (
                                <div ref={this.Tienda}>
                                    <TiendaPremios mostrarPanel={this.mostrarPanel} mostrarConsulta={this.mostrarConsulta} nivelaso={this.state.nivelaso} correo={this.state.correo} telcel={this.state.telcel} idcliente={this.state.idcliente} puntos={this.state.puntos} nomcom={this.state.nomcom} nit={this.state.nit} tipoiden={this.state.tipoiden} />
                                </div>
                            );
                        default:
                            return null;
                    }
                })()}
                <MensajeF />
                <Footer />
            </div>
        );
    }
}

export default Coopenautas;